import LogNoteForm from './LogNote';
export default LogNoteForm;
